var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{style:(_vm.myStyles),attrs:{"data":_vm.chartData,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }